module.exports = __webpack_public_path__ + "static/assets/ff604ee848c4601eed6cdba13c6b461f.png";